import React from "react";
import styles from "./searchDropDown.module.scss";
import ReactLoading from "react-loading";
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";

interface HeaderDropdownProps {
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  translations?: any;
  searchData: any[];
  loading: boolean;
  searchValue: string;
  onItemClick?: () => void;
}

const SearchDropDown: React.FC<HeaderDropdownProps> = ({
  onMouseEnter,
  onMouseLeave,
  translations,
  searchData,
  loading,
  searchValue,
  onItemClick,
}) => {
  const theme = useSelector((state: RootState) => state.theme.mode);
  const location = useLocation();
  const loaderColor = theme === "dark" ? "#ffffff" : "#344733";
  const safeSearchData = Array.isArray(searchData) ? searchData : [];

  if (!loading && safeSearchData.length === 0 && !searchValue.trim()) {
    return null;
  }

  return (
    <div
      className={styles.dropdownContainer}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className={styles.dropDownContent}>
        {loading ? (
          <div className={styles.loadingContainer}>
            <ReactLoading type="spin" color={loaderColor} height={42} width={42} />
            <span className={styles.loadingText}>Axtarılır...</span>
          </div>
        ) : safeSearchData.length === 0 ? (
          <div className={styles.noResultWrapper}>
            <p className={styles.noResultText}>
              {translations?.no_result || "Nəticə tapılmadı"}
            </p>
          </div>
        ) : (
          safeSearchData.map((product, index) => {
            const productTitle: string =
              product.name ||
              product.title ||
              product.product_name ||
              product.subject ||
              "Məhsul";
            const productSlug: string | number =
              product.slug ||
              product.product_slug ||
              product.id ||
              product.num_iid ||
              product.offerId ||
              product.item_id ||
              index;
            const productImage: string =
              product.cover_image ||
              product.image ||
              product.pic_url ||
              product.img ||
              product.image_url ||
              "";
            const productPrice: string | number =
              product.price ??
              product.promotion_price ??
              product.discount_price ??
              product.original_price ??
              "";
            const currency: string = product.currency || "AZN";
            const channel: string = product.channel || "";

            return (
              <Link
                to={`/productDetail/${productSlug}`}
                state={{
                  from: `${location.pathname}${location.search}`,
                  fromSearch: true,
                }}
                key={product.id || index}
                className={styles.searchItemLink}
                onClick={onItemClick}
                tabIndex={0}
                aria-label={productTitle}
              >
                <div className={styles.searchCover}>
                  {productImage ? (
                    <img src={productImage} alt={productTitle} className={styles.productImage} />
                  ) : (
                    <div className={styles.productImage} />
                  )}
                  <div className={styles.searchTextContent}>
                    <div className={styles.searchTitle} title={productTitle}>
                      {productTitle}
                    </div>
                    <div className={styles.searchMeta}>
                      <span className={styles.searchPrice}>
                        {productPrice} {currency}
                      </span>
                      {channel && (
                        <span className={styles.channelBadge}>{channel}</span>
                      )}
                    </div>
                    {product.product_description && (
                      <div className={styles.searchDescription}>
                        <p>
                          {product.product_description.length > 70
                            ? `${product.product_description.substring(0, 70)}...`
                            : product.product_description}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            );
          })
        )}
      </div>
    </div>
  );
};

export default SearchDropDown;
